import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: '¿Funciona si mi hijo ya tiene 6 o 7 años?',
  a: 'Sí. Está diseñado para niños de 2 a 7 años. Los pasos de comunicación verbal son incluso más efectivos con niños más grandes que ya tienen más lenguaje.'
}, {
  q: '¿Tengo que leerlo todo antes de aplicarlo?',
  a: 'No. El Capítulo 3 con los 3 pasos del método lo lees en 20 minutos y ya tienes todo lo esencial para aplicar hoy mismo.'
}, {
  q: '¿Funciona si yo también tengo poca paciencia?',
  a: 'Sí. El protocolo incluye una sección específica para gestionar tu propio estado interno antes de intervenir. No asume que llegas calmado.'
}, {
  q: '¿Es un libro largo?',
  a: 'No. Está diseñado para leerse en 90 minutos o menos. Cada capítulo termina con un checklist de aplicación inmediata. Sin relleno.'
}, {
  q: '¿Qué pasa si no funciona en exactamente 3 minutos?',
  a: 'El nombre representa una intervención rápida. A veces tomará menos, otras un poco más. Lo importante es que tendrás una estructura clara en lugar de improvisar desde el miedo.'
}, {
  q: '¿Es solo para madres?',
  a: 'No. Está escrito para madres, padres, abuelos y cualquier cuidador que pase tiempo con niños de 2 a 7 años.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <SectionWrapper className="bg-white py-20 pb-32" data-id="element-143">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center" data-id="element-144">
        Preguntas frecuentes
      </h2>

      <div className="space-y-4 max-w-3xl mx-auto mb-16" data-id="element-145">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border-b border-hairline overflow-hidden" data-id="element-146">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-147">
              <span className="font-sans text-lg font-bold text-ink pr-4 flex items-start gap-3" data-id="element-148">
                <span className="text-coral shrink-0" data-id="element-149">❓</span>
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-ink-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-150" />
            </button>
            <AnimatePresence data-id="element-151">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-152">
                  <div className="px-6 pb-6 pl-14 font-sans text-ink-mid leading-relaxed flex items-start gap-3 font-medium" data-id="element-153">
                    <span className="text-green-500 shrink-0 mt-1" data-id="element-154">✅</span>
                    <p data-id="element-155">{faq.a}</p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>

      <div id="comprar-final" className="max-w-2xl mx-auto scroll-mt-24" data-id="element-156">
        <CTAButton fullWidth data-id="element-157">QUIERO MI PROTOCOLO AHORA</CTAButton>
      </div>
    </SectionWrapper>;
}